$(document).ready(function () {
    var promotions = $("[data-promotiongtm]");

    if (!promotions || promotions.length === 0) {
        return;
    }

    promotions.each(function (position, promotion) {
        var $promotion = $(promotion);
        var promotionGtmDataValue = $promotion.attr("data-promotiongtm");

        // Validate attribute
        if (
            !promotionGtmDataValue ||
            typeof promotionGtmDataValue !== "string"
        ) {
            return;
        }

        // Safe JSON parse
        var promotionGtmData;
        try {
            promotionGtmData = JSON.parse(promotionGtmDataValue);
        } catch (e) {
            return;
        }

        // Validate object
        if (!promotionGtmData || typeof promotionGtmData !== "object") {
            return;
        }

        // Find parent safely
        var promotionParentElement = $promotion
            .parent()
            .closest("div[data-position]");

        var creativeName = "Home Page";
        var creativeSlot = "Default";

        if (promotionParentElement.length > 0) {
            var positionAttr = promotionParentElement.attr("data-position");
            var promotionPosition = parseInt(positionAttr, 10);

            if (!isNaN(promotionPosition)) {
                creativeName = "Home Page Carousel";
                creativeSlot = "Slide-" + (promotionPosition + 1);
            }
        } else {
            promotionParentElement = $promotion.parent().closest("div");
        }

        // Normalize IDs
        var promotionId =
            promotionGtmData.promotion_id ||
            promotionGtmData.id ||
            "unknown_promotion";

        var promotionName =
            promotionGtmData.promotion_name ||
            promotionGtmData.name ||
            "unknown_promotion";

        // Sending view_promotion Event GA4 (1 push per promotion)
        var promoViewGtmEvent = {
            event: "view_promotion",
            ecommerce: {
                creative_name: creativeName,
                creative_slot: creativeSlot,
                promotion_id: promotionId,
                promotion_name: promotionName,
            },
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(promoViewGtmEvent);

        // Prevent multiple click bindings
        promotionParentElement.off("click.ga4Promo");

        // Sending select_promotion Event GA4
        promotionParentElement.on("click.ga4Promo", function () {
            var promoClickGtmEvent = {
                event: "select_promotion",
                ecommerce: {
                    creative_name: creativeName,
                    creative_slot: creativeSlot,
                    promotion_id: promotionId,
                    promotion_name: promotionName,
                },
            };

            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(promoClickGtmEvent);
        });
    });
});
